class PaymentStatusElement extends HTMLElement {
  connectedCallback() {
    this.pollCount = 0;

    if (this.getAttribute("payment-status") === "pending" && this.pollUrl) {
      this.poll();
    }
  }

  async poll() {
    const response = await fetch(this.pollUrl, {
      headers: { Accept: "application/json" },
    });

    const purchase = await response.json();
    this.setPaymentStatus(purchase.payment_status);
  }

  setPaymentStatus(paymentStatus) {
    if (paymentStatus === "paid") {
      this.setAttribute("payment-status", "paid");
    } else if (paymentStatus === "failed") {
      this.setAttribute("payment-status", "failed");
    } else if (this.pollCount < 15) {
      this.pollCount += 1;
      window.setTimeout(() => this.poll(), 500);
    }
  }

  get pollUrl() {
    return this.getAttribute("poll-url");
  }
}

if (!window.customElements.get("payment-status")) {
  window.customElements.define("payment-status", PaymentStatusElement);
}
